export default {
  listGenders: [],
  gender: {
    ativo: true,
    id: 0,
    nome: '',
    sigla: '',
  },
}
